import React from "react";
import { FormGroup, FormControl, FormLabel } from "react-bootstrap";
import classes from "./SelectOption.module.css";
interface Props {
  label: string;
  supportLabel: string;
  options?: string[];
  elementLabelStyle: {};
  elementInputStyle: {};
  name: string;
  errorText: string;
  value?: string;
  onChange: (event) => void;
}
const selectOption: React.FunctionComponent<Props> = (props) => {
  const {
    label,
    supportLabel,
    options,
    elementLabelStyle,
    elementInputStyle,    
    name,
    errorText,
    value,
    onChange,
  } = { ...props };
  return (
    <FormGroup className={classes.formGroup}>
      <FormLabel style={elementLabelStyle} className={classes.formLabel}>
        {label}
        <small>{supportLabel}</small>
      </FormLabel>
      <FormControl
        as="select"
        size="lg"
        custom
        className={classes.customSelect}
        style={elementInputStyle}
        name={name}
        value={value}
        onChange={onChange}>
        {options ?
          options && options.map((ele) => (
            <option key={ele} value={ele}>{ele}</option>
          )) :
          <option key="value" value="value">{value}</option>
        }
      </FormControl>
      <span className={classes.errorMsg}>{errorText}</span>
    </FormGroup>
  );
};
export default selectOption;
